// AI Card Scanner — single source of truth for availability (Phase 1).
//
// PROMOTION TO PRODUCTION: to turn the scanner on for collectionkeeper.org,
// change isScannerHostEnabled() below to return true (or widen the host check).
// This is the ONLY place to flip it — the scanner page AND the set-page
// "SCAN A CARD" button both read from here, so they can never drift apart.

// The only sets the scanner can identify this phase (catalog is loaded for
// exactly these three slugs in the scan-card edge function).
export const SCANNER_SET_IDS = ['2021-chrome-galaxy', '2022-chrome-galaxy', '2023-chrome-galaxy', '2024-chrome-galaxy', '2025-chrome-galaxy', '2026-galaxy', '2018-galaxy', '2025-chrome', '2024-topps-chrome-sw', '2025-masterwork', '2025-smugglers-outpost', '2025-hyperspace', '2024-chrome-black', '2026-chrome'];

// LIVE everywhere as of the Phase 1 production launch (2026-06-15).
// KILL SWITCH: to hide the scanner again (all hosts), return false here; to
// restrict it back to staging only, restore the hostname check below.
//   const h = window.location.hostname;
//   return h === 'localhost' || h.startsWith('127.') || h.includes('netlify') || h.includes('staging');
export function isScannerHostEnabled() {
  return true;
}

// True when this set is one the scanner supports (drives the set-page button).
export function isScannerSet(setId) {
  return SCANNER_SET_IDS.includes(setId);
}
